import { authnClient } from '@frontend/auth';
import { AuthStorage } from '@frontend/auth-helpers';
import { getSsoConnection } from './auth-api-service';
import { ssoCallbackStore } from './sso-storage';

/**
 * Fetch the SSO connection for the given tenant and redirect to the IdP login page.
 */
export async function redirectToIdPLogin(tenant: string): Promise<void> {
  const ssoTenant = await getSsoConnection(tenant);

  ssoCallbackStore.setItem(AuthStorage.sso_tenant, {
    tenant,
    clientId: ssoTenant.clientId,
    redirectUri: ssoTenant.redirectUri,
  });

  // this will result in a top level nav to the IdP login page
  await authnClient.useAuthMethod('oidc').signIn({
    clientId: ssoTenant.clientId,
    redirectUri: ssoTenant.redirectUri,
  });
}
